import {
    Doc,
    GSTTreatment,
    PlaceOfSupply,       
    Tax,       
    Unit}   from    "../../../../common/common.model";
import { CustomerRef } from "../customers/customer.model";

export class Invoice extends Doc {
    public customer             :   CustomerRef;
    public number               :   string;
    public date                 :   Date;
    public billingAddress       :   string;
    public gstTreatment         :   GSTTreatment;
    public gstin                :   string;
    public placeOfSupply        :   PlaceOfSupply;
    public items                :   InvoiceItem[];
    public subTotal             :   number;
    public cgst                 :   number;
    public sgst                 :   number;
    public total                :   number;

    constructor(data: any = {}) {
        super(data);
        this.customer           =   new CustomerRef(data.customer);
        this.number             =   data.number         ||  '';
        this.date               =   typeof data.date === 'object' ? data.date.toDate(): new Date(data.date);
        this.billingAddress     =   data.billingAddress ||  '';
        this.gstTreatment       =   data.gstTreatment   ||  GSTTreatment.None;
        this.gstin              =   data.gstin          ||  '';
        this.placeOfSupply      =   data.placeOfSupply  ||  PlaceOfSupply.TN;
        this.items              =   data.items ? data.items.map((item: InvoiceItem) => new InvoiceItem(item)) : [];
        this.subTotal           =   data.subTotal       ||  0;
        this.cgst               =   data.cgst           ||  0;
        this.sgst               =   data.sgst           ||  0;
        this.total              =   data.total          ||  0;
    }

    public toJson() {
        return {
            ...this,
            date: this.date,
            customer: this.customer.toJson(),
            items: this.items.map((item: InvoiceItem) => item.toJson())
        };
    }
}

export enum ItemType {
    Goods                       =   'Goods',
    Service                     =   'Service'
}

export class Item extends Doc {
    public type                 :   ItemType;
    public sku                  :   string;
    public unit                 :   Unit;
    public rate                 :   number;
    public tax                  :   Tax;
    public hsnCode              :   string;
    public name                 :   string;

    constructor(data: any = {}) {
        super(data);
        this.type               =   data.type       ||  ItemType.Goods;
        this.sku                =   data.sku        ||  '';
        this.unit               =   data.unit       ||  Unit.KG;
        this.rate               =   data.rate       ||  0;
        this.tax                =   data.tax        ||  Tax.GST0;
        this.hsnCode            =   data.hsnCode    ||  '';
        this.name               =   data.name       ||  '';
    }

    public toJson() {
        return {
            ...this
        };
    }
}

export class InvoiceItem extends Item{
    public quantity             :   number;
    public amount               :   number;

    public rowId                :   number;

    constructor(data: any = {}) {
        super(data);
        this.quantity           =   data.quantity   ||  1;
        this.amount             =   data.amount     ||  this.quantity * this.rate;

        this.rowId              =   data.rowId      ||  0;
    }

    public toJson() {
        return {
            ...this
        };
    }
}